/* Antistatik · accueil v3 (E1, 23/10/2026) : boucle motion design de la section « Comment ça marche »
   (sections/ask-accueil-etapes.liquid).
   - La vidéo ne reçoit son adresse qu'après le chargement complet de la page, et seulement quand elle est à l'écran :
     rien ne passe avant l'image principale du héros.
   - Lecture muette en boucle tant qu'elle est visible, mise en pause hors de l'écran.
   - Bouton Pause / Lecture toujours présent (WCAG 2.2.2) ; un clic sur Pause est respecté jusqu'au prochain clic.
   - Sous « réduire les animations » ou en économie de données : pas de lecture automatique, image fixe et bouton Lecture. */
(function () {
  'use strict';
  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var eco = navigator.connection && navigator.connection.saveData;

  function preparer(fig) {
    if (fig.getAttribute('data-ask-video-pret')) return;
    fig.setAttribute('data-ask-video-pret', '1');
    var v = fig.querySelector('video');
    var btn = fig.querySelector('[data-ask-video-btn]');
    if (!v || !btn) return;
    var voulu = fig.getAttribute('data-auto') === 'true' && !reduit && !eco;
    var visible = false;

    function charger() {
      if (v.getAttribute('src')) return;
      v.muted = true;
      v.src = fig.getAttribute('data-src');
    }
    function maj() {
      var lit = !v.paused && !v.ended;
      fig.classList.toggle('is-lecture', lit);
      btn.setAttribute('aria-label', lit ? 'Mettre la vidéo en pause' : 'Lire la vidéo');
    }
    function jouer() {
      charger();
      var p = v.play();
      if (p && p.catch) p.catch(function () { maj(); });
    }

    v.addEventListener('play', maj);
    v.addEventListener('pause', maj);
    v.addEventListener('playing', function () { fig.classList.add('is-prete'); maj(); });
    btn.addEventListener('click', function () {
      if (v.paused) { voulu = true; jouer(); }
      else { voulu = false; v.pause(); }
    });

    maj();
    /* La lecture automatique n'est surveillée qu'après le chargement complet de la page (le bouton marche dès l'affichage). */
    apresChargement(function () {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entrees) {
          entrees.forEach(function (e) {
            visible = e.isIntersecting;
            if (visible && voulu) jouer();
            else if (!visible && !v.paused) v.pause();
          });
        }, { threshold: 0.25 }).observe(fig);
      } else if (voulu) {
        jouer();
      }
    });
  }

  function apresChargement(fn) {
    if (document.readyState === 'complete') setTimeout(fn, 300);
    else window.addEventListener('load', function () { setTimeout(fn, 300); });
  }
  function tout() {
    document.querySelectorAll('[data-ask-video]').forEach(preparer);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout);
  else tout();
  /* Éditeur de thème : la section rechargée est préparée de nouveau. */
  document.addEventListener('shopify:section:load', tout);
})();
